exports = module.exports = require("../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._simple-circle__simple-circle__34NWa {\n  margin: auto;\n  border-color: #f2f2f2;\n  border-style: solid;\n  border-radius: 50%;\n  animation: _simple-circle__spin-circle__3c6qV 1s infinite linear; }\n\n@keyframes _simple-circle__spin-circle__3c6qV {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(359deg); } }\n", ""]);

// exports
exports.locals = {
	"simple-circle": "_simple-circle__simple-circle__34NWa",
	"spin-circle": "_simple-circle__spin-circle__3c6qV"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]__[hash:base64:5]!./~/postcss-loader!./~/sass-loader!./~/rctui/styles/spin/_simple-circle.scss
// module id = 420
// module chunks = 0 1